export class ApiModel {
    id: string;
    apiPref: string;
    getUrl() {}
    toJSON() {}
}
